import api from '@/api';
import { settingsGdiParams } from '../libs/formats/gdiParams';

/*
    Модель для ГДИ фильтра.
*/

export const gdiFilterReportModel = {
    name: 'gdiFilterReport',
    state: {
        /*
            Выбранная скважина (её id)
        */
        activeWellId: null,
        /*
            Выбранное исследование (её id)
        */
        activeResearch: null,
        /*
            Список скважин (информация берется из запроса за WSE деревом)
        */
        wells: null,
        /*
            Список исследований для выбранной скважины (результат запроса)

            TODO: нужно сделать словарь, куда кэшировать каждый набор исследований по id скважины.
            Не будем лишний раз дергать сервер и быстрее получать уже загруженную информацию.
        */
        researchByWell: null,
        /*
            Поля индикаторы загрузки researches
        */
        isLoadingResearch: false,
        isErrorResearch: false,
    },
    reducers: {
        setActiveWellId(state, wellId) {
            return { ...state, activeWellId: wellId };
        },
        setActiveResearch(state, research) {
            return { ...state, activeResearch: research };
        },
        setWells(state, wells) {
            return { ...state, wells, activeWellId: null, activeResearch: null, researchByWell: null };
        },
        setResearchesByWell(state, response) {
            return { ...state, researchByWell: response, isLoadingResearch: false };
        },
        startRequest(state) {
            return { ...state, isLoadingResearch: true, isErrorResearch: false };
        },
        setError(state) {
            return { ...state, isLoadingResearch: false, isErrorResearch: true, researchByWell: null };
        },
        /*
            Сброс всех полей, которые участвуют в работе фильтра
        */
        resetFilter(state) {
            return { ...state, activeWellId: null, activeResearch: null, researchByWell: null };
        },
    },
    effects: dispatch => ({
        setActiveResearchEffect(research) {
            dispatch.gdiFilterReport.setActiveResearch(research); // sync
            dispatch.reports.finishWithoutTree();
        },
        setGdiWellsEffect(_, rootState) {
            const { data } = rootState.reports.matches;
            const { setWells } = dispatch.gdiFilterReport;

            let wells = data.wellsWithInquiry ?? [];
            if (wells.length > 1)
                wells = wells.sort((a, b) => a.title.localeCompare(b.title, undefined, { numeric: true }));

            setWells(wells);
        },
        /*
            Запрос за исследованиями. Опирается на выбранную из списка скважину (wellId)
        */
        async fetchInquiryResearch(payload) {
            const { wellId, signal } = payload;
            const { startRequest, setResearchesByWell, setError } = dispatch.gdiFilterReport;

            startRequest();

            try {
                const response = await api.reports.getInquiryResearch(wellId, signal);
                setResearchesByWell(response);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log('%c gdi researches error', 'color: red;', error);
                setError();
            }
        },
        /*
            Формирование параметров для отчета согласно полям Report Builder-a
        */
        getFilterParams(reportTypePath, rootState) {
            const { activeWellId, activeResearch } = rootState.gdiFilterReport;

            const result = {
                reportType: reportTypePath,
            };

            if (activeWellId && activeResearch) {
                const result = {
                    reportType: reportTypePath,
                };

                return Object.assign(result, settingsGdiParams(activeWellId, activeResearch));
            }

            return result;
        },
    }),
};
